import React from 'react';

const AVATAR_COLORS = [
  ['#1F5A45', '#E7F0EA'],
  ['#B6791A', '#F7EBD3'],
  ['#3F6FB0', '#E6EDF6'],
  ['#B5546B', '#F6E6EA'],
  ['#0C8587', '#DEF3F3'],
  ['#7A5BA6', '#EEE8F5'],
];

function hashStr(value = '') {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

function PlatformAvatar({ name = '', size = 40, photoUrl }) {
  const [fg, bg] = AVATAR_COLORS[hashStr(name) % AVATAR_COLORS.length];
  const initials = name
    .split(' ')
    .filter(Boolean)
    .map((part) => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt=""
        className="platform-avatar"
        style={{ width: size, height: size, objectFit: 'cover' }}
      />
    );
  }

  return (
    <div
      className="platform-avatar"
      style={{
        width: size,
        height: size,
        background: bg,
        color: fg,
        fontSize: size * 0.36,
      }}
      aria-hidden="true"
    >
      {initials || '?'}
    </div>
  );
}

export default PlatformAvatar;
